/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Action category of the request.
*/
export enum AuditLogAction {
  AuditLogActionUnspecified = 'AUDIT_LOG_ACTION_UNSPECIFIED',
  Trigger = 'TRIGGER',
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE',
  Read = 'READ',
  Auth = 'AUTH'
}
